import { render, staticRenderFns } from "./TableResponsive.vue?vue&type=template&id=52493149&scoped=true&"
import script from "./TableResponsive.vue?vue&type=script&lang=js&"
export * from "./TableResponsive.vue?vue&type=script&lang=js&"
import style0 from "./TableResponsive.vue?vue&type=style&index=0&id=52493149&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52493149",
  null
  
)

export default component.exports